import React from "react";

const Terms = () => {
  return (
    <section class="legal-container">
      <h1>Terms and Conditions</h1>
      <p>
        <strong>AlFurqan International</strong>
      </p>
      <p>
        <em>Last updated: January 2026</em>
      </p>

      <p>
        By accessing or using our services, you agree to be bound by these Terms
        and Conditions ("Terms").
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        You must be at least 18 years old or have parental consent to use our
        services. By using the platform, you agree to comply with these Terms.
      </p>

      <h2>2. User Accounts</h2>
      <ul>
        <li>You are responsible for maintaining account security</li>
        <li>You must provide accurate and complete information</li>
        <li>We may suspend or terminate accounts for violations</li>
      </ul>

      <h2>3. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the service for unlawful purposes</li>
        <li>Attempt unauthorized access</li>
        <li>Upload malicious or harmful content</li>
        <li>Impersonate others</li>
      </ul>

      <h2>4. Intellectual Property</h2>
      <p>
        All content, trademarks, logos, and software are the property of
        AlFurqan International unless otherwise stated.
      </p>

      <h2>5. Payments and Transactions</h2>
      <p>
        All payments are final unless stated otherwise. We are not responsible
        for third-party payment processing errors.
      </p>

      <h2>6. Termination</h2>
      <p>
        We reserve the right to suspend or terminate access to our services
        without notice if these Terms are violated.
      </p>

      <h2>7. Disclaimer</h2>
      <p>
        Our services are provided "as is" and "as available" without warranties
        of any kind.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        AlFurqan International shall not be liable for indirect, incidental, or
        consequential damages.
      </p>

      <h2>9. Governing Law</h2>
      <p>
        These Terms are governed by the laws applicable in the jurisdiction
        where AlFurqan International operates.
      </p>

      <h2>10. Changes to Terms</h2>
      <p>
        We may update these Terms at any time. Continued use of the services
        constitutes acceptance of the updated Terms.
      </p>

      <h2>11. Contact Information</h2>
      <p>
        <strong>AlFurqan International</strong>
        <br />
        Email: support@alfurqaninternational.org
        <br />
        Website: https://alfurqaninternational.org
      </p>
    </section>
  );
};

export default Terms;
